import * as config from "../config.js";

export const RETRIEVED_WORKFLOWS = "RETRIEVED_WORKFLOWS";
export const RETRIEVED_WORKFLOW = "RETRIEVED_WORKFLOW";
export const RETRIEVED_NODES = "RETRIEVED_NODES";
export const RETRIEVED_NODE = "RETRIEVED_NODE";
export const RETRIEVED_FUNCTIONS = "RETRIEVED_FUNCTIONS";
export const RETRIEVED_FUNCTION = "RETRIEVED_FUNCTION";
export const WORKFLOW_ERROR = "WORKFLOW_ERROR";
export const NODE_ERROR = "NODE_ERROR";
export const FUNCTION_ERROR = "FUNCTION_ERROR";
export const SAVING_WORKFLOW = "SAVING_WORKFLOW";
export const SAVING_NODE = "SAVING_NODE";
export const RUNNING_NODE = "RUNNING_NODE";
export const RUN_NODE_RESULTS = "RUN_NODE_RESULTS";
export const RUNNING_WORKFLOW = "RUNNING_WORKFLOW";
export const RUN_WORKFLOW_RESULTS = "RUN_WORKFLOW_RESULTS";
export const SAVING_FUNCTION = "SAVING_FUNCTION";
export const SAVED_WORKFLOW = "SAVED_WORKFLOW";
export const SAVED_NODE = "SAVED_NODE";
export const SAVED_FUNCTION = "SAVED_FUNCTION";
export const CLEAR_SAVED_WORKFLOW = "CLEAR_SAVED_WORKFLOW";
export const CLEAR_SAVED_NODE = "CLEAR_SAVED_NODE";
export const CLEAR_SAVED_FUNCTION = "CLEAR_SAVED_FUNCTION";
export const CLEAR_RUNNING_NODE = "CLEAR_RUNNING_NODE";
export const ADD_FUNCTION_TO_NODE = "ADD_FUNCTION_TO_NODE";
export const RETRIEVED_TRAINING_WORKFLOWS = "RETRIEVED_TRAINING_WORKFLOWS";
export const RETRIEVED_INFERENCE_WORKFLOWS = "RETRIEVED_INFERENCE_WORKFLOWS";
export const RETRIEVED_SUPPORTING_CONTENT_WORKFLOWS =
  "RETRIEVED_SUPPORTING_CONTENT_WORKFLOWS";

export const getWorkflow = (public_id) => {
  return (dispatch) => {
    // We dispatch requestLogin to kickoff the call to the API
    fetch(`${config.REST_SERVER_URL}/admin/workflow/${public_id}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "include",
    })
      .then((response) => response.json())
      .then((workflow) => {
        dispatch({
          type: RETRIEVED_WORKFLOW,
          workflow: workflow,
        });
      })
      .catch((error) =>
        dispatch(
          workflowError(`Something was wrong. Try again: ${error}`, false)
        )
      );
  };
};

export const getWorkflows = () => {
  return (dispatch) => {
    // We dispatch requestLogin to kickoff the call to the API
    //dispatch(requestLogin(creds));
    fetch(`${config.REST_SERVER_URL}/admin/workflow`, {
      method: "GET",
      crossDomain: true,
      headers: {
        "Content-Type": "application/json",
      }, credentials: "include",
    })
      .then((response) => response.json())
      .then((workflows) => {
        dispatch({
          type: RETRIEVED_WORKFLOWS,
          workflows: workflows,
        });
      })
      .catch((error) =>
        dispatch(
          workflowError(`Something was wrong. Try again: ${error}`, false)
        )
      );
  };
};

export const getTrainingWorkflows = () => {
  return (dispatch) => {
    // We dispatch requestLogin to kickoff the call to the API
    //dispatch(requestLogin(creds));
    fetch(`${config.REST_SERVER_URL}/admin/workflow/type/training`, {
      method: "GET",
      crossDomain: true,
      headers: {
        "Content-Type": "application/json",
      }, credentials: "include",
    })
      .then((response) => response.json())
      .then((workflows) => {
        dispatch({
          type: RETRIEVED_TRAINING_WORKFLOWS,
          workflows: workflows,
        });
      })
      .catch((error) =>
        dispatch(
          workflowError(`Something was wrong. Try again: ${error}`, false)
        )
      );
  };
};

export const getSupportingContentWorkflows = () => {
  return (dispatch) => {
    // We dispatch requestLogin to kickoff the call to the API
    //dispatch(requestLogin(creds));
    fetch(`${config.REST_SERVER_URL}/admin/workflow/type/supporting content`, {
      method: "GET",
      crossDomain: true,
      headers: {
        "Content-Type": "application/json",
      }, credentials: "include",
    })
      .then((response) => response.json())
      .then((workflows) => {
        dispatch({
          type: RETRIEVED_SUPPORTING_CONTENT_WORKFLOWS,
          workflows: workflows,
        });
      })
      .catch((error) =>
        dispatch(
          workflowError(`Something was wrong. Try again: ${error}`, false)
        )
      );
  };
};

export const getInferenceWorkflows = () => {
  return (dispatch) => {
    // We dispatch requestLogin to kickoff the call to the API
    //dispatch(requestLogin(creds));
    fetch(`${config.REST_SERVER_URL}/admin/workflow/type/inference`, {
      method: "GET",
      crossDomain: true,
      headers: {
        "Content-Type": "application/json",
      }, credentials: "include",
    })
      .then((response) => response.json())
      .then((workflows) => {
        dispatch({
          type: RETRIEVED_INFERENCE_WORKFLOWS,
          workflows: workflows,
        });
      })
      .catch((error) =>
        dispatch(
          workflowError(`Something was wrong. Try again: ${error}`, false)
        )
      );
  };
};

export const addFunctionToNode = (funct) => {
  return {
    type: ADD_FUNCTION_TO_NODE,
    functionToAdd: funct,
  };
};

export const saveWorkflow = (workflow) => {
  if (workflow?.archive_id) {
    console.log("!!! CAN'T SAVE ARCHIVE: ", workflow.archive_id);
    return;
  }

  return (dispatch) => {
    // We dispatch requestLogin to kickoff the call to the API
    dispatch(savingWorkflow(true));
    const method = workflow.id ? "PUT" : "POST";
    const url = workflow.id
      ? `${config.REST_SERVER_URL}/admin/workflow/${workflow.public_id}`
      : `${config.REST_SERVER_URL}/admin/workflow`;
    fetch(url, {
      method: method,
      crossDomain: true,
      headers: {
        "Content-Type": "application/json",
      }, credentials: "include",
      body: JSON.stringify(workflow),
    })
      .then((response) => response.json())
      .then((workflow) => {
        dispatch({
          type: SAVED_WORKFLOW,
          savedWorkflow: workflow,
        });

        // For now, just reload the workflow
        dispatch(getWorkflow(workflow.public_id));
        dispatch(getWorkflows());
      })
      .catch((error) =>
        dispatch(
          workflowError(`Something was wrong. Try again: ${error}`, false)
        )
      )
      .finally(() => {
        dispatch(savingWorkflow(false));
      });
  };
};

export const saveArchiveWorkflow = (workflow_id, title) => {
  return (dispatch) => {
    // We dispatch requestLogin to kickoff the call to the API
    const url = `${config.REST_SERVER_URL}/admin/workflow/${workflow_id}/archive`;
    fetch(url, {
      method: "POST",
      crossDomain: true,
      headers: {
        "Content-Type": "application/json",
      }, credentials: "include",
      body: JSON.stringify({ title: title }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("!!! DATA: ", data);
      })
      .catch((error) =>
        dispatch(
          workflowError(`Something was wrong. Try again: ${error}`, false)
        )
      )
      .finally(() => {
        dispatch(savingWorkflow(false));
      });
  };
};

export const getNode = (public_id) => {
  return (dispatch) => {
    // We dispatch requestLogin to kickoff the call to the API
    fetch(`${config.REST_SERVER_URL}/admin/node/${public_id}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      }, credentials: "include",
    })
      .then((response) => response.json())
      .then((node) => {
        dispatch({
          type: RETRIEVED_NODE,
          node: node,
        });
      })
      .catch((error) =>
        dispatch(nodeError(`Something was wrong. Try again: ${error}`, false))
      );
  };
};

export const getNodes = () => {
  return (dispatch) => {
    // We dispatch requestLogin to kickoff the call to the API
    //dispatch(requestLogin(creds));
    fetch(`${config.REST_SERVER_URL}/admin/node`, {
      method: "GET",
      crossDomain: true,
      headers: {
        "Content-Type": "application/json",
      }, credentials: "include",
    })
      .then((response) => response.json())
      .then((nodes) => {
        dispatch({
          type: RETRIEVED_NODES,
          nodes: nodes,
        });
      })
      .catch((error) =>
        dispatch(nodeError(`Something was wrong. Try again: ${error}`, false))
      );
  };
};

export const saveNode = (node) => {
  return (dispatch) => {
    // We dispatch requestLogin to kickoff the call to the API
    dispatch(savingNode(true));
    const method = node.id ? "PUT" : "POST";
    const url = node.id
      ? `${config.REST_SERVER_URL}/admin/node/${node.public_id}`
      : `${config.REST_SERVER_URL}/admin/node`;
    fetch(url, {
      method: method,
      crossDomain: true,
      headers: {
        "Content-Type": "application/json",
      }, credentials: "include",
      body: JSON.stringify(node),
    })
      .then((response) => response.json())
      .then((node) => {
        console.log("!!! SAVED NODE: ", node);
        dispatch({
          type: SAVED_NODE,
          savedNode: node,
        });

        // For now, just reload the agents
        dispatch(getNode(node.public_id));
        dispatch(getNodes());
      })
      .catch((error) =>
        dispatch(nodeError(`Something was wrong. Try again: ${error}`, false))
      )
      .finally(() => {
        dispatch(savingNode(false));
      });
  };
};

export const runNode = (node_id, params, properties, context) => {
  return (dispatch) => {
    // We dispatch requestLogin to kickoff the call to the API
    dispatch(runningNode(true));
    const url = `${config.REST_SERVER_URL}/admin/node/${node_id}/run`;
    fetch(url, {
      method: "POST",
      crossDomain: true,
      headers: {
        "Content-Type": "application/json",
      }, credentials: "include",
      body: JSON.stringify({
        input_params: params,
        properties: properties,
        context: context,
      }),
    })
      .then((response) => response.json())
      .then((results) => {
        dispatch({
          type: RUN_NODE_RESULTS,
          results: results,
        });
      })
      .catch((error) =>
        dispatch(nodeError(`Something was wrong. Try again: ${error}`, false))
      )
      .finally(() => {
        dispatch(runningNode(false));
      });
  };
};

const runningWorkflow = (running) => {
  return {
    type: RUNNING_WORKFLOW,
    running: running,
  };
};

export const runWorkflow = (workflow_id, input) => {
  return (dispatch) => {
    // We dispatch requestLogin to kickoff the call to the API
    dispatch(runningWorkflow(true));
    const url = `${config.REST_SERVER_URL}/admin/workflow/${workflow_id}/run`;
    fetch(url, {
      method: "POST",
      crossDomain: true,
      headers: {
        "Content-Type": "application/json",
      }, credentials: "include",
      body: input,
    })
      .then((response) => response.text())
      .then((output) => {
        dispatch({
          type: RUN_WORKFLOW_RESULTS,
          results: output,
        });
      })
      .catch((error) =>
        dispatch(
          workflowError(`Something was wrong. Try again: ${error}`, false)
        )
      )
      .finally(() => {
        dispatch(runningWorkflow(false));
      });
  };
};

const nodeError = (error) => {
  return {
    type: NODE_ERROR,
    error: error,
  };
};

export const getFunction = (public_id) => {
  return (dispatch) => {
    // We dispatch requestLogin to kickoff the call to the API
    //dispatch(requestLogin(creds));
    fetch(`${config.REST_SERVER_URL}/admin/function/${public_id}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      }, credentials: "include",
    })
      .then((response) => response.json())
      .then((funct) => {
        dispatch({
          type: RETRIEVED_FUNCTION,
          funct: funct,
        });
      })
      .catch((error) =>
        dispatch(
          functionError(`Something was wrong. Try again: ${error}`, false)
        )
      );
  };
};

export const getFunctions = () => {
  return (dispatch) => {
    // We dispatch requestLogin to kickoff the call to the API
    //dispatch(requestLogin(creds));
    fetch(`${config.REST_SERVER_URL}/admin/function`, {
      method: "GET",
      crossDomain: true,
      headers: {
        "Content-Type": "application/json",
      }, credentials: "include",
    })
      .then((response) => response.json())
      .then((functions) => {
        dispatch({
          type: RETRIEVED_FUNCTIONS,
          functions: functions,
        });
      })
      .catch((error) =>
        dispatch(
          functionError(`Something was wrong. Try again: ${error}`, false)
        )
      );
  };
};

const functionError = (error) => {
  return {
    type: FUNCTION_ERROR,
    error: error,
  };
};

export const saveFunction = (funct) => {
  return (dispatch) => {
    // We dispatch requestLogin to kickoff the call to the API
    //dispatch(requestLogin(creds));
    dispatch(savingFunction(true));
    const method = funct.id ? "PUT" : "POST";
    const url = funct.id
      ? `${config.REST_SERVER_URL}/admin/function/${funct.public_id}`
      : `${config.REST_SERVER_URL}/admin/function`;
    fetch(url, {
      method: method,
      crossDomain: true,
      headers: {
        "Content-Type": "application/json",
      }, credentials: "include",
      body: JSON.stringify(funct),
    })
      .then((response) => response.json())
      .then((funct) => {
        dispatch({
          type: SAVED_FUNCTION,
          savedFunction: funct,
        });

        // For now, just reload the agents
        dispatch(getFunction(funct.public_id));
        dispatch(getFunctions());
      })
      .catch((error) =>
        dispatch(
          functionError(`Something was wrong. Try again: ${error}`, false)
        )
      )
      .finally(() => {
        dispatch(savingFunction(false));
      });
  };
};

const workflowError = (error) => {
  return {
    type: WORKFLOW_ERROR,
    error: error,
  };
};

const savingWorkflow = (saving) => {
  return {
    type: SAVING_WORKFLOW,
    saving: saving,
  };
};

const savingNode = (saving) => {
  return {
    type: SAVING_NODE,
    saving: saving,
  };
};

const runningNode = (running) => {
  return {
    type: RUNNING_NODE,
    running: running,
  };
};

const savingFunction = (saving) => {
  return {
    type: SAVING_FUNCTION,
    saving: saving,
  };
};

export const clearFunction = () => {
  return {
    type: RETRIEVED_FUNCTION,
    funct: null,
  };
};

export const clearNode = () => {
  return {
    type: RETRIEVED_NODE,
    node: null,
  };
};

export const clearWorkflow = () => {
  return {
    type: RETRIEVED_WORKFLOW,
    workflow: null,
  };
};

export const clearSavedWorkflow = () => {
  return {
    type: CLEAR_SAVED_WORKFLOW,
  };
};

export const clearSavedNode = () => {
  return {
    type: CLEAR_SAVED_NODE,
  };
};

export const clearRunningNode = () => {
  return (dispatch) => {
    dispatch({
      type: RUN_NODE_RESULTS,
      results: null,
    });
  };
};

export const clearRunningWorkflow = () => {
  return (dispatch) => {
    dispatch({
      type: RUN_WORKFLOW_RESULTS,
      results: null,
    });
  };
};

export const clearSavedFunction = () => {
  return {
    type: CLEAR_SAVED_FUNCTION,
  };
};

export const downloadWorkflow = async (public_id, title) => {
  try {
    const response = await fetch(
      `${config.REST_SERVER_URL}/admin/workflow/${public_id}/json`,
      {
        method: "GET",
        crossDomain: true,
        headers: {
          "Content-Type": "application/json",
        }, credentials: "include",
      }
    );

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.style.display = "none";
    a.href = url;
    a.download = `${title}.json`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("There was an error downloading the file:", error);
  }
};
